import React, { useState } from 'react';

// Full Page Loader Component
const FullPageLoader = ({ isLoading, message = "Processing..." }) => {
  if (!isLoading) return null;

  return (
  <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm space-y-4">
  <div className="relative">
    <div className="w-16 h-16 border-4 border-blue-200 rounded-full animate-spin"></div>
    <div className="absolute top-0 left-0 w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
  </div>
  <div className="text-center">
    <h3 className="text-lg font-semibold text-white mb-2">
      Please wait...
    </h3>
    <p className="text-sm text-gray-300">
      {message}
    </p>
  </div>
</div>

  );
};

export default FullPageLoader;
